export default __webpack_public_path__ + "static/media/illustration-algowork-m@3x.8fc0bc8b.png";